import classNames from "classnames"
import { Weekday } from "../types"
import {
   getDisplayedWeekdays,
   WEEKDAY_LABELS,
   WEEKDAYS_IN_ORDER,
} from "../utils"
import "./index.scss"

interface WeekdayPillsProps {
   value: Weekday[]
   onChange?: (weekdays: Weekday[]) => void
   editable?: boolean
}

export const WeekdayPills = ({
   value,
   onChange,
   editable = false,
}: WeekdayPillsProps) => {
   const toggleWeekday = (weekday: Weekday) => {
      const nextSelection = value.includes(weekday)
         ? value.filter((selected) => selected !== weekday)
         : [...value, weekday]

      onChange?.(WEEKDAYS_IN_ORDER.filter((day) => nextSelection.includes(day)))
   }

   return (
      <div className="weekday-pills">
         {getDisplayedWeekdays().map((weekday) => {
            const isSelected = value.includes(weekday)

            return (
               <button
                  key={weekday}
                  type="button"
                  disabled={!editable}
                  aria-pressed={isSelected}
                  className={classNames("weekday-pills__pill", {
                     "weekday-pills__pill--selected": isSelected,
                     "weekday-pills__pill--editable": editable,
                  })}
                  onClick={() => toggleWeekday(weekday)}
               >
                  {WEEKDAY_LABELS[weekday]}
               </button>
            )
         })}
      </div>
   )
}
